import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./components/App";
import store from "./components/store";

import "./assets/scss/app.scss";


ReactDOM.render(
    <Provider store={store}>
        <div className="load" id="app-loading">
            <div className="material-loading">
                <svg className="load-icon">
                    <circle cx="25" cy="25" r="20" fill="none" strokeWidth="6" strokeMiterlimit="10"/>
                </svg>
            </div>
        </div>
        <App />
    </Provider>, document.getElementById('root')
);
